module.exports = __webpack_public_path__ + "media/images/kids1-630aec9e06ec9904592d9467667783a7.jpg";